var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarousleUndeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 9,
    viewBox: "0 0 352 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1 1 106.58 7.95113 174.427 7.99974C243.501 8.04923 351 1 351 1",
    stroke: "#F1F0F0",
    strokeOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousleUndeline);
export default __webpack_public_path__ + "static/media/carousleUndeline.b2bd6e4f2fcd23b8de705a604588f8b2.svg";
export { ForwardRef as ReactComponent };